// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b5-4";
export var closeButton = "_b5-6";
export var dismissButton = "_b5-3";
export var editImageWithAiContainer = "_b5-8";
export var imageUploadWrapper = "_b5-7";
export var misspelledWord = "_b5-5";
export var spellCheckContainer = "_b5-2";
export var spin = "_b5-1";
export var spinning = "_b5-0";